module.exports = __webpack_public_path__ + "static/media/header-banner-1.043a5bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-banner-1.png
// module id = 189
// module chunks = 0